import React, { useState, useEffect } from 'react';
import { ItemDepartmentName, ItemDepartmenListSelect } from '../../item/DepartmentItems';

export function AdminDepartmentContent({list, department, sn, sm}){
  const[mDepartment, setDepartment] = useState({})
  const[departmentName, setDepartmentName] = useState("")
  const[managerDepartmentId, setManagerDepartmentId] = useState("")
    
  useEffect(()=>{
    if(department !== undefined && department !== mDepartment){
      setDepartment(department)
      setDepartmentName(department.departmentName)
      setDepartmentId(department.managerDepartmentId)
    }
  },[department])
  

    function setName(val){
      setDepartmentName(val)
        if(sn!==undefined)
        sn(val)
    }
    function setDepartmentId(val){
      setManagerDepartmentId(val)
        if(sm!==undefined)
            sm(val)
    }
    return(
      <>
      <div className="row">
        <div className="col-sm-6">
            <ItemDepartmentName departmentName={departmentName} setDepartmentName={setName} />
        </div>
        <div className="col-sm-6">
            <ItemDepartmenListSelect departmentList={list} managerDepartmentId={managerDepartmentId} setManagerDepartmentId={setDepartmentId} />
        </div>
      </div>
      </>
    )
  }